
import { Avatar, Button, Chip, Skeleton, Typography } from "../../../../../components/common"
import { CalendarIcon, DownloadIcon } from "../../../../../theme/icons"
import { WhiteBreifCaseIcon } from "../../../../../theme/icons2"
import propTypes from "prop-types"
import moment from "moment"
import { generateBGColorClassName } from "../../../../../utils/randomColor"

const SingleItem = ({ children = <></>, title = "", }) => {
    return (<div className='flex flex-col gap-2.5'>
        <Typography className="text-secondary-400 font-normal text-[14px]" text={title} />
        {children}
    </div>
    )
}

const commonProps = {
    children: propTypes.any,
    title: propTypes.string
}

SingleItem.propTypes = commonProps;

export const TicketBasicDetails = (props) => {
    const { viewGreyTHRTicket = {}, loading = false, rowIndex = 0 } = props || { viewGreyTHRTicket: {}, loading: false }
    const { requester = {}, client = {}, custom_fields = {}, created_at = "", updated_at = "", status = '', attachments = [], responder = {} } = viewGreyTHRTicket || { attachments: [], requester: {}, client: {}, custom_fields: {}, created_at: "", status: "", responder: {}, type: null }

    const statusVariables = {
        '2': <Chip variant="chip-deep-purple" text="Open" />,
        '3': <Chip variant="chip-orange" text="Pending" />,
        '5': <Chip variant="chip-success" text="Closed" />,
        '4': <Chip variant="chip-salmon" text="Resolved" />,
        '8': <Chip variant="chip-salmon" text="On Hold" />
    }

    return (<div className='w-full border-b py-4 border-secondary-200'>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-x-2 gap-y-4 ">
            <SingleItem title="Ticket Raised on Date & Time" >
                <div className='flex items-center gap-1'>
                    <CalendarIcon />
                    {loading ?
                        <Skeleton className="w-full h-4 rounded-sm" /> : <Typography variant="base" className="text-secondary-600 font-normal" text={moment(created_at)?.format('DD MMM YYYY HH:mm A')} />}
                </div>
            </SingleItem>
            <SingleItem title="Ticket Last Updated Date & Time" >
                <div className='flex items-center gap-1'>
                    <CalendarIcon />
                    {loading ?
                        <Skeleton className="w-full h-4 rounded-sm" /> : <Typography variant="base" className="text-secondary-600 font-normal" text={moment(updated_at)?.format('DD MMM YYYY HH:mm A')} />}
                </div>
            </SingleItem>
            <SingleItem title="Ticket Status">
                <div className='flex items-center gap-1'>
                    {loading ?
                        <Skeleton className="w-full h-4 rounded-sm" /> : statusVariables?.[status]}
                </div>
            </SingleItem>
            <SingleItem title="Raised by" >
                <div className='flex items-center gap-2'>
                    {loading ? <LoaderWithAvatar /> : <>
                        <Avatar type="text"
                            className={`${generateBGColorClassName(rowIndex)}`}
                            alt={requester?.name} />
                        <div>
                            <Typography variant="base" className="text-secondary-600 capitalize font-normal" text={requester?.name || "_"} />
                            <Typography className="text-secondary-400 text-[14px] font-normal" text={requester?.email || "_"} />
                        </div>
                    </>}
                </div>
            </SingleItem>
            {responder?.name && <SingleItem title="Agent Assigned">
                <div className='flex   items-center gap-1'>
                    {loading ? <div className="w-full flex flex-col gap-1" >
                        <Skeleton className="w-full h-6 rounded-sm" />
                        <Skeleton className="w-full h-4 rounded-sm" />
                    </div> : <div>
                        <Typography variant="base" className="text-secondary-600 capitalize font-normal" text={responder?.name || "Support Agent"} />
                        <Typography className="text-secondary-400 text-[14px] font-normal" text={responder?.email || ""} />
                    </div>}
                </div>
            </SingleItem>}
            <SingleItem title="Client Name" >
                <div className='flex items-center gap-2'>
                    {loading ? <LoaderWithAvatar /> : <>
                        <Avatar type="svg" alt="" className={`${generateBGColorClassName(rowIndex + 1)}`} src={<WhiteBreifCaseIcon />} />
                        <div>
                            <Typography variant="base" className="text-secondary-600 capitalize font-normal" text={client?.name || "_"} />
                            <Typography className="text-secondary-400 text-[14px] font-normal" text={custom_fields?.cf_domain_name949839 || "_"} />
                        </div></>}
                </div>
            </SingleItem>
            <SingleItem title="Query Category" >
                <div className='flex items-center gap-1'>
                    {loading ?
                        <Skeleton className="w-full h-4 rounded-sm" /> :
                        <Typography variant="base" className="text-secondary-600 font-normal" text={custom_fields?.cf_query_categorymodule319717 || "_"} />}
                </div>
            </SingleItem>
            <SingleItem title="Query Sub-category" >
                <div className='flex items-center gap-1'>
                    {loading ?
                        <Skeleton className="w-full h-4 rounded-sm" /> :
                        <Typography variant="base" className="text-secondary-600 font-normal" text={custom_fields?.cf_query_sub_category6723 || "_"} />}
                </div>
            </SingleItem>
            <SingleItem title="Query Type" >
                <div className='flex items-center gap-1'>
                    {loading ?
                        <Skeleton className="w-full h-4 rounded-sm" /> :
                        <Typography variant="base" className="text-secondary-600 font-normal" text={custom_fields?.cf_query_type945824 || "_"} />}
                </div>
            </SingleItem>
            <SingleItem title="Attatchments" >
                <div className='flex items-center gap-1'>
                    {loading ?
                        <Skeleton length={2} className="w-full h-4 my-0.5 rounded-sm" /> :
                        <Attatchments attachments={attachments} />}
                </div>
            </SingleItem>
        </div>
    </div>)
}

const LoaderWithAvatar = () => (<div className="flex gap-1 w-full justify-start">
    <Skeleton length={1} parentClassName="w-fit" className="w-[35px] h-[35px] rounded-full" />
    <div className="w-full flex flex-col gap-1">
        <Skeleton length={1} className="w-full h-6 rounded-sm" />
        <Skeleton length={1} className="w-full h-4 rounded-sm" />
    </div>
</div>)

const Attatchments = ({ attachments = [] }) => {
    return (<>{attachments?.length > 0 ? attachments?.map(attach =>
        <a key={attach?.id} href={attach?.attachment_url} download={attach?.name}>
            <Button
                iconPos="r"
                variant="tertiary"
                className="flex  text-primary-600 items-center justify-end p-0 mr-0 bg-transparent border-0"
                icon={<DownloadIcon className="h-4 w-4" />} text={attach?.name} />
        </a>) : <Typography variant="base" className="text-secondary-600 font-normal" text={"_"} />}</>)
}

Attatchments.propTypes = {
    attachments: propTypes.array
}